import {canUseDOM} from '../canUseDOM';

export const getScrollBehavior = () => {
    const prefersReducedMotion =
        canUseDOM &&
        typeof window.matchMedia === 'function' &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    return prefersReducedMotion ? 'auto' : 'smooth';
};
